// extracted by mini-css-extract-plugin
module.exports = {"filter_by":"universities-filter_filter_by__Tttrf","filter_buttons":"universities-filter_filter_buttons__dsksN"};